import React, { useEffect, useState } from 'react'
import { FiAlertTriangle, FiArrowLeftCircle, FiList, FiSave, FiSlash } from 'react-icons/fi';
import { Table } from '../../components/tables/Table';
import { useDispatch, useSelector } from 'react-redux';
import { changedState, loadDetailRequest, receiveRequest } from '../../app/store/requests/thunk';
import { InputValidators } from '../../utils/InputValidators';
import Swal from 'sweetalert2';
import { Loading } from '../../components/Loading';
import { loadEvidences } from '../../app/store/evidences/thunk';
import { Uploader } from '../../components/Uploader';
import { ModalGallery } from '../../components/ModalGallery';

export const ReceiveRequests = ({ navigateTo, data }) => {

    const dispatch = useDispatch();
    const { isLoading, detailRequest, detailItems, msg } = useSelector(state => state.requests);
    const { usuario, id_emp } = useSelector(state => state.usuario);
    const { evidencesItems } = useSelector(state => state.evidences);

    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => {
        setShowModal(false);
        //   // setSearchType(null);
    };

    useEffect(() => {
        dispatch(loadDetailRequest(data?.id || 0));
        dispatch(loadEvidences(data?.id || 0));
    }, []);


    let user = id_emp;
    const purcharseOrder = detailRequest;

    const [ProductsToADD, setProductsToADD] = useState([]);

    useEffect(() => {
        setProductsToADD(detailItems || []);
    }, [detailItems]);
    const purchaseOrderDetails = ProductsToADD;


    const handleChangeReceivedQty = (sku, value) => {
        setProductsToADD(prev =>
            prev.map(p => {
                if (p.SKU !== sku) return p;

                const receivedBefore = Number(p.QUANTITY_LAST_REGISTER ?? 0);
                const receivedNow = Number(value ?? 0);
                const approved = Number(p.QUANTITY_APPROVED ?? 0);

                const totalReceived = receivedBefore + receivedNow;

                // Validación de exceso
                // if (totalReceived > approved) {
                //     Swal.fire({
                //         icon: 'warning',
                //         title: 'Cantidad inválida',
                //         text: 'La cantidad recibida no puede ser mayor a la cantidad aprobada',
                //         customClass: {
                //             confirmButton: 'btn btn-primary  me-2',
                //         },

                //     });
                //     return p;
                // }

             const statusId =   totalReceived >= approved ? 5 : 4; // 5 = COMPLETO, 4 = PARCIAL

                return {
                    ...p,
                    QUANTITY_RECEIVED: receivedNow,
                    STATUSID: statusId
                };
            })
        );
    };


    const handleAddObservations = (sku, value) => {
        setProductsToADD(prev =>
            prev.map(p =>
                p.SKU === sku ? { ...p, COMMENTS: value } : p
            )
        );
    };

    let listProductsAddColumns = [
        {
            header: 'SKU',
            dataIndex: 'SKU',
            classHeader: 'text-start',
            classRow: 'text-start',

        },
        {
            header: 'CATEGORIA',
            dataIndex: 'NAMECATEGORY',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'MARCA',
            dataIndex: 'NAMEBRAND',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'PRODUCTO',
            dataIndex: 'NAME_PRODUCT',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'DESCRIPCION',
            dataIndex: 'DESCRIPTION_PRODUCT',
            classHeader: 'text-start',
            classRow: 'text-start',
        },

        {
            header: 'PROVEEDOR',
            dataIndex: 'NAMESUPPLIER',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'CANT. APROBADA',
            dataIndex: 'QUANTITY_APPROVED',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'CANT. RECIBIDA ANTERIOR',
            dataIndex: 'QUANTITY_LAST_REGISTER',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => value ?? 0
        },
        {
            header: 'CANT. A RECIBIR',
            dataIndex: 'QUANTITY_RECEIVED',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value, row) => (
                <input
                    type="number"
                    className="form-control text-center"
                    min={0}
                    onKeyDown={InputValidators.validateOnlyNumbers}
                    style={{ width: "80px", margin: "0 auto" }}
                    value={Number(value ?? '')}
                    onChange={(e) => handleChangeReceivedQty(row.SKU, Number(e.target.value))}
                />
            )
        },
        {
            header: 'OBSERVACIONES',
            dataIndex: 'COMMENTS',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value, row) => (
                <textarea
                    className="form-control text-start"
                    onKeyDown={InputValidators.validateAlphanumeric}
                    style={{ width: '240px' }}
                    onChange={(e) => handleAddObservations(row.SKU, e.target.value)}
                />
            )
        },


    ];

    const saveData = () => {
        const allCompleted = ProductsToADD.every(p => p.STATUSID === 5);
        const orderStatus = allCompleted ? 6 : 5;
        const productsNormalized = ProductsToADD.map(p => ({
            ...p,
            COMMENTS: p.COMMENTS ?? ''   // si no existe o es null → ''
        }));

        Swal.fire({
            title: 'Atención',
            text: `Está por recibir productos de la Orden de compra ${purcharseOrder?.NUMBER}, se actualizaran las existencias de los productos, ¿Desea de continuar con esta acción?`,
            icon: 'question',
            customClass: {
                confirmButton: 'btn btn-primary  me-2',
                cancelButton: 'btn btn-secondary'
            },
            showCancelButton: true,
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, cancelar',
            buttonsStyling: false
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(receiveRequest(productsNormalized, user, purcharseOrder?.NUMBER, orderStatus));
                navigateTo('list');
            }
        })
    }

    // changedState

    const chanegeStateOrder = (e) => {

        let status = e.target.value;
        Swal.fire({
            title: 'Atención',
            text: `Está por cambiar el estado de la Orden de compra ${purcharseOrder?.NUMBER}, ¿Desea de continuar con esta acción?`,
            icon: 'question',
            customClass: {
                confirmButton: 'btn btn-primary  me-2',
                cancelButton: 'btn btn-secondary'
            },
            showCancelButton: true,
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, cancelar',
            buttonsStyling: false
        }).then((result) => {
            if (result.isConfirmed) {
                // changedState
                dispatch(changedState(user, purcharseOrder?.NUMBER, status));
                // 
                if (status == 7 || status == 6) {
                    navigateTo('list');
                }
            }
        })
    }





    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <>
            {showModal && (<ModalGallery onClose={handleCloseModal} images={evidencesItems} closeOnEscape={true} closeOnBackdrop={true} />)}
            <div className='row'>
                <div className='col-12 mb-3'>
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center  ">
                        <div className="d-flex mb-1">
                            <button className="btn btn-outline-dark border-0" onClick={() => navigateTo('list')}>
                                <FiArrowLeftCircle size={23} />
                            </button>
                            <h1 className="h4 fw-bold mt-2"> | Detalles de Orden [ Recibir Orden ]</h1>
                        </div>
                    </div>
                </div>

                <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                    <div className="card">
                        <div className="card-header border-bottom">
                            <h5 className="card-title mb-0 fw-bold text-dark">Orden de compra: {purcharseOrder?.NUMBER}</h5>
                        </div>
                        <div className="card-body">
                            <div className="mb-2">
                                <label className="form-label">Capturo:</label>
                                <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.USERNAME_REGISTER} />
                            </div>
                            <div className='d-flex'>
                                <div className="mb-2 me-3">
                                    <label className="form-label">Fecha:</label>
                                    <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.DATEREGISTER} />
                                </div>
                                <div className="mb-2">
                                    <label className="form-label">Hora:</label>
                                    <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.HOURREGISTER} />
                                </div>
                            </div>

                            <div className="mb-2">
                                <label className="form-label">Estado:</label>
                                <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.STATUSDESC} />
                            </div>
                            {evidencesItems?.length > 0 && (
                                <div className='text-center'>
                                    <button type="button" className="btn btn-outline-dark" onClick={() => { setShowModal(true); }} >
                                        <FiList size={22} /> Ver evidencias registradas
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    <Uploader reference={purcharseOrder?.NUMBER} userRegister={user} />
                </div>

                <div className='col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9'>
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-start flex-wrap border-bottom">
                            <div>
                                <h4 className="mb-0 fw-bold text-dark">Orden de compra</h4>
                                <div className="d-flex flex-wrap mt-1">
                                    <span className="badge text-bg-primary me-2">{purcharseOrder?.STATUSDESC}</span>
                                </div>
                            </div>
                            <div className="mb-3 me-4">
                                <label className="form-label">Estado de la Orden de compra:</label>
                                <select className="form-select" value={purcharseOrder?.STATUSID || 0} onChange={(e) => chanegeStateOrder(e)}  >
                                    <option value={3}>APROBADO</option>
                                    <option value={4}>POR RECIBIR</option>
                                    <option value={5}>PARCIAL</option>
                                    <option value={6}>COMPLETO</option>
                                    <option value={7}>CANCELADO</option>
                                </select>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className='row'>
                                <div className='col-12'>
                                    <Table
                                        columns={listProductsAddColumns}
                                        data={purchaseOrderDetails}
                                        function_={[]}
                                        placeholderSearch="Buscar por: Folio, Capturante, Fecha, Estado"
                                        showPagination={false}
                                        showControls={false}
                                        showTotals={false}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='card-footer text-end border-top'>
                            <button type="button" className="btn btn-outline-danger me-2" > <FiSlash size={22} /> Cancelar </button>
                            <button onClick={saveData} type="button" className="btn btn-outline-primary"> <FiSave size={22} /> Guardar </button>
                        </div>
                    </div>
                </div>
            </div>
         </>
    )
}
